import * as React from 'react';

export const ScrollUpSymbol = (props) => (
<svg width="63.1" className={props.className} onClick={props.onClick} height="63.1" viewBox="0 0 63.1 63.1">
  <g id="Group_9942_1_" transform="translate(-14.949 -575.95)">
  <g id="Ellipse_2787_1_" transform="translate(15 576)">
      <circle id="Ellipse_2793" data-name="Ellipse 2793" className="icon-background" cx="29.8" cy="29.5" r="29.8"
        transform="translate(1.7 1.7)" fill="none" stroke="#0067c5" strokeWidth="3.5"/>
    </g>
    <g id="outline-call_made-24px_1_" transform="translate(16.029 594) rotate(-45)">
      <path id="Path_9079_1_" d="M6.7,18.8v3.5H18.2L-2,42.6.5,45.1,20.8,24.8V36.3h3.5V18.8Z" fill="#0067c5"/>
    </g>
  </g>
</svg>);
